import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled, { css } from 'styled-components'

import { ELotStatus, LotStatus } from '@bonhams1793/bonhams-typescript'

import { decodeHtml } from '@nx/decode-html'
import { Body } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import { WonLot } from '../WonLot/WonLot'
import { StyledWonLotContainer } from './FinishedLotStatus.styles'
import translate from './FinishedLotStatus.translate.json'

const { text } = getTranslate(translate)

export const FinishedLotStatus = memo(
  ({
    lotStatus,
    hammerPrice,
    hammerPremium,
    currencySymbol,
    isUserWinner,
    invoiceId,
    isResultPublished,
  }: FinishedLotStatusProps) => {
    if (lotStatus === LotStatus.withdrawn) {
      return <StyledSoldPrice $uppercase>{text('withdrawn')}</StyledSoldPrice>
    }

    if (isUserWinner) {
      return (
        <StyledWonLotContainer>
          <WonLot
            currencySymbol={currencySymbol}
            soldPrice={hammerPremium ? hammerPremium : hammerPrice}
            isPremium={!!hammerPremium}
            invoiceId={invoiceId ? invoiceId : undefined}
            variant="primary"
          />
        </StyledWonLotContainer>
      )
    }

    if (
      isResultPublished &&
      lotStatus === LotStatus.sold &&
      (hammerPremium || hammerPrice)
    ) {
      return (
        <StyledSoldPrice>
          {hammerPremium
            ? text('premium', {
                price: buildPriceString({
                  currencySymbol: decodeHtml(currencySymbol),
                  lowPrice: hammerPremium,
                }),
              })
            : text('price', {
                price: buildPriceString({
                  currencySymbol: decodeHtml(currencySymbol),
                  lowPrice: hammerPrice,
                }),
              })}
        </StyledSoldPrice>
      )
    }

    if (lotStatus === LotStatus.sold) {
      return <StyledSoldPrice>{text('sold')}</StyledSoldPrice>
    }

    return null
  },
  isEqual
)

export const StyledSoldPrice = styled(Body)<{ $uppercase?: boolean }>`
  ${({ $uppercase }) => css`
    width: 100%;

    ${$uppercase &&
    css`
      text-transform: uppercase;
    `}
  `}
`

export interface FinishedLotStatusProps {
  lotStatus: ELotStatus
  hammerPrice: number
  hammerPremium: number
  currencySymbol: string
  isUserWinner: boolean
  invoiceId?: string
  isResultPublished: boolean
}
